import { type ReactNode } from "react"
import { LoaderCircle } from "lucide-react"

import { Button } from "@/components/ui/button"
import { StepActions } from "@/components/ui/stepper"

export function BaseGeneratorForm({
  children,
  buttonText,
  generatorType,
  isLoading,
}: {
  children: ReactNode
  buttonText: string
  generatorType: string
  isLoading: boolean
}) {
  return (
    <>
      {children}
      <StepActions className="mt-12">
        <Button
          type="submit"
          size="lg"
          className="mx-auto flex h-auto w-full border-2 border-blue-500 py-4 font-semibold first-letter:capitalize"
          data-attr-generator="generator-start-btn"
          data-attr-generator-type={generatorType}
          disabled={isLoading}
        >
          {isLoading && (
            <LoaderCircle
              className="-ms-1 me-2 animate-spin"
              size={16}
              strokeWidth={2}
              aria-hidden="true"
            />
          )}
          {buttonText}
        </Button>
      </StepActions>
    </>
  )
}
